export function computeCommissionRange(rules) {
    const amounts = rules
        .filter((r) => r.commission_type === 'PERCENTAGE')
        .map((r) => r.commission_amount);
    if (amounts.length === 0)
        return null;
    const min = Math.min(...amounts);
    const max = Math.max(...amounts);
    return min === max ? `${min}%` : `${min}-${max}%`;
}
